import "../../styles/all.css";
import "./viosn.css";
import visonphoto from "../../img/vision-1.png";
import visonphototwo from "../../img/vision-2.png";
import { useTranslation } from "react-i18next";

function Vison() {
  const { t } = useTranslation();

  return (
    <div className="vison" data-aos="flip-right">
      <div className="left">
        <div className="info">
          <h3>{t("vision_title")}</h3>
          <span>{t("vision_tags")}</span>
          <p>{t("vision_shorttext")}</p>
        </div>

        <div className="four_text">
          <p>{t("vision_point1")}</p>
          <p>{t("vision_point2")}</p>
          <p>{t("vision_point3")}</p>
          <p>{t("vision_point4")}</p>
        </div>
      </div>

      <div className="right">
        <div className="image">
          <img src={visonphoto} alt="vision" />
          <div className="box">
            <h4>45+</h4>
            <h5>{t("vision_experience")}</h5>
          </div>
          <img src={visonphototwo} alt="vision overlay" />
        </div>
      </div>
    </div>
  );
}

export default Vison;
